<template>
    <div class="flex items-center">

          <a class="cursor-pointer text-sm" v-show="isHidden" v-on:click="isHidden = !isHidden"><i aria-hidden="true" class="material-icons align-middle mr-1">visibility</i>View Email</a>
          
          <div v-if="!isHidden" class="flex w-full items-center" v-click-outside="onClickOutside">
            <slot></slot>
          </div>
        
      </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

  export default {
    directives: {
      clickOutside: vClickOutside.directive
    },
    data() {
      return {
        isHidden: true,
      }
    },
    methods: {
      onClickOutside (event) {
          this.isHidden = !this.isHidden
      },
    },
  };
</script>
